import React from "react";
import { Link } from "react-router-dom";
import { XCircle, Phone as PhoneIcon, Home, ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import { businessInfo } from "../mock";

const BookingCancelled = () => {
  return (
    <div className="text-left bg-black text-white min-h-screen">
      <Header />
      <main className="pt-28 pb-16">
        <div className="max-w-2xl mx-auto px-5 lg:px-8 text-center">
          <div className="w-20 h-20 rounded-full bg-zinc-800 mx-auto flex items-center justify-center">
            <XCircle className="w-12 h-12 text-zinc-400" />
          </div>
          <h1 className="mt-6 text-white font-extrabold text-3xl lg:text-4xl tracking-tight">
            Payment Cancelled
          </h1>
          <p className="mt-4 text-zinc-300 text-base lg:text-lg leading-relaxed">
            No worries — nothing was charged. You can try booking again, or call Shane directly to schedule.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild className="bg-brand-red text-white font-semibold h-12 px-6">
              <Link to="/book">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Try Again
              </Link>
            </Button>
            <Button asChild variant="outline" className="h-12 px-6 bg-transparent border-zinc-700 text-zinc-200 hover:bg-zinc-900">
              <a href={`tel:${businessInfo.phoneRaw}`}>
                <PhoneIcon className="w-4 h-4 mr-2" />
                Call {businessInfo.phone}
              </a>
            </Button>
            <Button asChild variant="outline" className="h-12 px-6 bg-transparent border-zinc-700 text-zinc-200 hover:bg-zinc-900">
              <Link to="/">
                <Home className="w-4 h-4 mr-2" />
                Home
              </Link>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BookingCancelled;
